import React from 'react';
import { performance, specs } from '../data/product';
export function SpecsSection() {
  return <section id="specs" className="scroll-mt-28 border-b border-white/10 bg-ink-900" data-id="element-1233" data-mp="3urdqlwdgmc97">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-1234" data-mp="3grcnsbdmwur3">
        <h2 className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-1235" data-mp="3lq61o4wu2nrs">
          Straight answers
          <br data-id="element-1236" data-mp="dbp21lkvdlwc" />
          <span className="text-grit-500" data-id="element-1237" data-mp="daw1518ldqm4">before you buy.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-steel-300" data-id="element-1238" data-mp="i8fiia0l6jia">
          The questions people actually ask us. No spec-sheet padding, no claims we can&apos;t back.
        </p>

        <ul className="mt-10 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1239" data-mp="8j4akqpfrkvz">
          {performance.map(item => <li key={item.label} className="flex h-full flex-col bg-ink-950 p-6" data-id="element-1240" data-mp="w8ghtl17divn">
              <p className="font-display text-6xl font-extrabold leading-none text-grit-500" data-id="element-1241" data-mp="110895xs6nsmu">{item.value}</p>
              <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.22em] text-offwhite" data-id="element-1242" data-mp="3eghet1rf8fvf">{item.label}</p>
              <p className="mt-3 text-[15px] leading-relaxed text-steel-400" data-id="element-1243" data-mp="39hmq5j6rvx3e">{item.note}</p>
            </li>)}
        </ul>

        <dl className="mt-6 grid gap-px border border-white/10 bg-white/10 lg:grid-cols-2" data-id="element-1244" data-mp="3n9kr36qbymoh">
          {specs.map(spec => <div key={spec.label} className="bg-ink-950 px-5 py-4 sm:px-6" data-id="element-1245" data-mp="1009m7wc2znb">
              <dt className="text-[11px] font-bold uppercase tracking-[0.2em] text-grit-500" data-id="element-1246" data-mp="3s6ta19jayuqs">{spec.label}</dt>
              <dd className="mt-1.5 text-[15px] leading-relaxed text-steel-200" data-id="element-1247" data-mp="a0y4o0osnwtr">{spec.value}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}